/**
 * Fonte única do enum de status do pedido — importado tanto pelo schema (Drizzle),
 * quanto pelo front (badges/labels) e pelo back (PDF, trava de edição), evitando
 * a lista duplicada que existia em 3 lugares diferentes.
 */
export const SALE_STATUSES = [
  'budget',
  'pending',
  'confirmed',
  'in_production',
  'ready',
  'shipped',
  'delivered',
  'canceled',
] as const;

export type SaleStatus = (typeof SALE_STATUSES)[number];

export const STATUS_LABELS: Record<string, string> = {
  budget: 'Orçamento',
  pending: 'Pendente',
  confirmed: 'Confirmado',
  in_production: 'Em Produção',
  ready: 'Pronto pra Envio',
  shipped: 'Enviado',
  delivered: 'Entregue',
  canceled: 'Cancelado',
};

/** Status em que o pedido ainda pode ser editado (composição, cliente, etc). */
export const EDITABLE_SALE_STATUSES: readonly SaleStatus[] = [
  'budget',
  'pending',
  'confirmed',
  'in_production',
];

export function isSaleEditable(status: string): boolean {
  return (EDITABLE_SALE_STATUSES as readonly string[]).includes(status);
}
